/* 
Author:Lamiaa Moustafa
Desc: All Sections containers styles js
*/
import styled from "styled-components";

//contact Page main container style
export const MainContainer = styled.section`
  width: 100%;
  height: 97vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
